<template>
  <div>
    <div v-if="cashOutData.id && !request && !incashment">
      <p>Рекомендованная сумма
        <strong>{{ Math.ceil(this.cashOutData.recommended_sum).toLocaleString('ru-RU') }}</strong></p>
      <div class="input-group">
        <input
          @change="checkCashOutSum"
          type="number"
          v-model="sum"
          class="form-control"
        />
        <vue-ladda
          @click="makeCashOut()"
          button-class="btn btn-success"
          data-style="zoom-in"
          :loading="loading"
        >Отправить
        </vue-ladda>
      </div>
    </div>
    <div v-else-if="request">
      <p class="badge badge-info">
        <strong>{{ moment(request.report_date, "HH:mm:ss DD.MM.YYYY") }}</strong>
      </p>
      <p>
        Сумма: <strong>{{ request.sum.toLocaleString("ru-RU") }}</strong>
      </p>
      <p>
        Старый конверт:
        <strong>{{ request.cash_amount.toLocaleString("ru-RU") }}</strong>
      </p>
      <p>
        Заявки:
        <strong>{{ request.adm_amount.toLocaleString("ru-RU") }}</strong> (сумма
        к сдаче - АВТОинкассация)
      </p>
      <p>
        ЗП: <strong>{{ request.salary_amount.toLocaleString("ru-RU") }}</strong>
      </p>
      <p>
        Почтовые р.:
        <strong>{{ request.post_amount.toLocaleString("ru-RU") }}</strong>
      </p>
      <hr/>
      <p>
        Калькуляция:
        <strong
        >{{ request.sum }} + {{ Math.round(request.cash_amount * 10) / 10 }} -
          {{ request.adm_amount }} - {{ request.salary_amount }} -
          {{ request.post_amount }}</strong
        >
      </p>
      <hr/>
      <p>
        Новый конверт:
        <strong>{{
            (
              request.sum -
              request.adm_amount -
              request.salary_amount -
              request.post_amount +
              request.cash_amount
            ).toLocaleString("ru-RU")
          }}</strong>
      </p>
      <p>
        Снято: <strong>{{ request.sum.toLocaleString("ru-RU") }}</strong>
      </p>
      <p>
        Автоинкассация:
        <strong>{{ request.adm_amount.toLocaleString("ru-RU") }}</strong>
      </p>
      <p
        v-bind:class="{
          badge: true,
          'badge-info': request.status === 1,
          'badge-success': request.status === 2
        }"
        v-if="cashOutData.incashment"
      >
        {{
          request.status === 2 ? "Подтверждено " + moment(cashOutData.incashment.created_at, "HH:mm:ss DD.MM.YYYY") : "На подтверждении"
        }}
      </p>
    </div>
    <div v-else>
      <p>Снятие недоступно в текущих условиях</p>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import moment from "moment";

export default {
  props: ["cashOutData", "division", "selectedDate", "actualRequest"],
  components: {
    VueLadda
  },
  data() {
    return {
      sum: 0,
      loading: false,
      request: null,
      incashment: null
    };
  },
  mounted() {
    if (this.actualRequest && this.actualRequest.request) {
      this.request = {...this.actualRequest.request};
    }
    if (this.actualRequest && this.actualRequest.incashment) {
      this.incashment = {...this.actualRequest.incashment};
    }
    this.sum = Math.ceil(this.cashOutData.recommended_sum);
  },
  methods: {
    checkCashOutSum() {
      if (this.sum < this.cashOutData.recommended_sum) {
        toastr["warning"]("Сумма не может быть меньше рекомендованной");
        // this.sum = Math.ceil(this.cashOutData.recommended_sum);
        return false
      }
      return true;
    },
    async makeCashOut() {
      if (!this.checkCashOutSum()) return;
      if (this.sum <= 0) {
        toastr["warning"]("Сумма не может быть 0 или отрицательной");
        return;
      }
      this.loading = true;
      const {data} = await api.post("/reports/makeCashOut", {
        division: this.division,
        sum: this.sum,
        date: this.selectedDate,
        recommended_sum: this.cashOutData.recommended_sum
      });
      if (!data.success) {
        toastr["warning"](data.message || "Ошибка запроса");
      } else {
        this.request = data.inCashRequest;
        toastr["success"]("Запрос сохранен");
      }
      this.loading = false;
    },
    moment: function (date, format) {
      if (!date) return;
      return moment(date).format(format);
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 2px;
}
</style>
